export const Logo = ({ size = "text-2xl" }) => (
  <div
    className={`font-heading font-bold ${size} tracking-tight flex items-baseline`}
    data-testid="jynova-logo"
  >
    <span style={{ color: "#C5A059" }}>JY</span>
    <span className="text-white">N</span>
    <span
      style={{
        color: "#00E5FF",
        textShadow: "0 0 18px rgba(0,229,255,0.7)",
      }}
    >
      O
    </span>
    <span className="text-white">VA</span>
  </div>
);

export default Logo;
